import {
    put,
    call,
    takeEvery,
    all
  } from 'redux-saga/effects';
import { globalLoaderText } from 'redux/CommonDashboard/actions';
import api from '../../client/utils/clientApiHelper' 
import OrganizationApiService from 'Service/Organization/OrganizationApiService';

import * as userProfileActions from './actions';

import {
    GET_COUNTRY_DROPDOWN,
    GET_BRANCH_VALUES,
    GET_USER_DETAIL,
    GET_USER_DETAIL_EXTERNAL
} from './types'
import { CONSTANTS } from 'client/utils/constants';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getCountryDropdownSaga():any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.Organization,
        endpoint: `organizations/dropdown/countries`,
        payload : null
    }

    try {
        const response = yield call( OrganizationApiService.post, API_URL.PostWebApp, payloadData);
        const defaultCountryDropdownOption = {
            "text": "Select",
            "value": null
          }
          response.unshift(defaultCountryDropdownOption); 
        yield put(userProfileActions.setCountryDropdown(response));
    } catch (error) {
        yield put(userProfileActions.setCountryDropdown([]));
} 
}

function* getBranchValues():any {
    try {
        yield put(globalLoaderText("Fetching branches..."));
        let payloadData : IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.Organization,
            endpoint: `organizations/hierarchy`,
            payload : null
        }
        const response = yield call(OrganizationApiService.post, API_URL.PostWebApp, payloadData);
        yield put(userProfileActions.setBranchValues(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(userProfileActions.setBranchValues([]));
        yield put(globalLoaderText(""));
    }

}

function* getUserDetails(req:any):any {
    try {
        const {user} = req.user;
        let payloadData : IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.Identity,
            endpoint: `userprofile/application/${CONSTANTS?.ORDER_MANAGEMENT}/user/${user}`,
            payload : null
        }

        const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData); 
        yield put(userProfileActions.setUserDetails(response));
        yield put(userProfileActions.SetBranch(response.branches));
    } catch (error) {
        yield put(userProfileActions.setUserDetails([]));
} 
}
//
function* getExternalUserDetails(req:any):any {
    try {
        const { value } = req
        let payloadData : IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.Identity,
            endpoint: `userprofile/bvusers/${value}`,
            payload: null
        }
        const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData );
        if (response?.emailAddress) {
            yield put(userProfileActions.setUserDetailsExternal(response));
        } else {
            yield put(userProfileActions.setUserDetailsExternal([{ userInternal: true }]));
        }
    } catch (error) {
        yield put(userProfileActions.setUserDetailsExternal([]));
} 
}

function* watchGetUserProfileSaga() {
    yield takeEvery(GET_COUNTRY_DROPDOWN, getCountryDropdownSaga);
    yield takeEvery(GET_BRANCH_VALUES,getBranchValues);
    yield takeEvery(GET_USER_DETAIL, getUserDetails);
    yield takeEvery(GET_USER_DETAIL_EXTERNAL, getExternalUserDetails);
}

export default function* combinedSaga() {
    yield all([
        watchGetUserProfileSaga()
    ])
}